import { useState, useEffect } from 'react';

const TABLE_DATA = [
  {
    id: 'wise',
    name: 'Wise',
    tagline: 'Transferencias bancarias',
    comision: 'Baja',
    comisionLabel: '~$0.99',
    comisionColor: 'text-green-600 bg-green-50 border-green-200',
    velocidad: 'Rápido',
    velocidadColor: 'text-amber-600 bg-amber-50 border-amber-200',
    mejorPara: 'Mejor tasa de cambio',
    badge: '#1 Recomendado',
    badgeColor: 'bg-green-500 text-white',
    btnLabel: 'Enviar con Wise',
    btnColor: 'bg-emerald-600 hover:bg-emerald-500 text-white',
    initials: 'W',
    bg: 'bg-emerald-600',
    link: 'https://wise.com/invite/dic/arlindad30',
    highlight: true,
  },
  {
    id: 'remitly',
    name: 'Remitly',
    tagline: 'Rápido y seguro',
    comision: 'Media',
    comisionLabel: '~$1.99',
    comisionColor: 'text-amber-600 bg-amber-50 border-amber-200',
    velocidad: 'Instantáneo disponible',
    velocidadColor: 'text-green-600 bg-green-50 border-green-200',
    mejorPara: 'Envíos rápidos / efectivo',
    badge: 'Más Rápido',
    badgeColor: 'bg-teal-100 text-teal-700',
    btnLabel: 'Enviar con Remitly',
    btnColor: 'bg-teal-600 hover:bg-teal-500 text-white',
    initials: 'R',
    bg: 'bg-teal-600',
    link: 'https://www.remitly.com/r/3ccs1e2j',
    highlight: false,
  },
  {
    id: 'westernunion',
    name: 'Western Union',
    tagline: 'Red física disponible',
    comision: 'Alta',
    comisionLabel: '~$4.99',
    comisionColor: 'text-red-500 bg-red-50 border-red-200',
    velocidad: 'Instantáneo',
    velocidadColor: 'text-green-600 bg-green-50 border-green-200',
    mejorPara: 'Cobro en efectivo',
    badge: 'Efectivo',
    badgeColor: 'bg-slate-100 text-slate-600',
    btnLabel: 'Enviar con Western Union',
    btnColor: 'bg-slate-800 hover:bg-slate-700 text-white',
    initials: 'WU',
    bg: 'bg-slate-600',
    link: 'https://ssqt.co/mQNlL2e',
    highlight: false,
  },
  {
    id: 'worldremit',
    name: 'WorldRemit',
    tagline: 'Cobertura global',
    comision: 'Media',
    comisionLabel: '~$2.99',
    comisionColor: 'text-amber-600 bg-amber-50 border-amber-200',
    velocidad: 'Rápido',
    velocidadColor: 'text-amber-600 bg-amber-50 border-amber-200',
    mejorPara: 'Cobertura amplia',
    badge: null,
    badgeColor: '',
    btnLabel: 'Enviar con WorldRemit',
    btnColor: 'bg-cyan-700 hover:bg-cyan-600 text-white',
    initials: 'WR',
    bg: 'bg-cyan-700',
    link: 'https://worldremit.com',
    highlight: false,
  },
];

export default function ComparisonTable() {
  const [minutesAgo, setMinutesAgo] = useState(() => Math.floor(Math.random() * 6) + 2);

  useEffect(() => {
    const interval = setInterval(() => {
      setMinutesAgo((prev) => prev + 1);
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const today = new Date().toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  return (
    <section id="comparar" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-5">
            <span className="inline-flex items-center gap-1.5 bg-green-100 text-green-700 text-xs font-bold px-3 py-1.5 rounded-full border border-green-200">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
              Actualizado hoy — {today}
            </span>
            <span className="inline-flex items-center gap-1.5 bg-slate-100 text-slate-600 text-xs font-semibold px-3 py-1.5 rounded-full">
              <i className="ri-time-line" />
              Última actualización: hace {minutesAgo} minutos
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Comparación de Servicios
          </h2>
          <p className="text-gray-500 text-sm max-w-lg mx-auto">
            Las tasas cambian constantemente — compara antes de enviar y ahorra en cada remesa.
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto rounded-2xl border border-gray-200">
          <table className="w-full text-sm bg-white">
            <thead>
              <tr className="bg-slate-50 border-b border-gray-200">
                <th className="text-left px-6 py-4 text-xs font-bold uppercase text-gray-400 tracking-wider">Servicio</th>
                <th className="text-center px-5 py-4 text-xs font-bold uppercase text-gray-400 tracking-wider">Comisión</th>
                <th className="text-center px-5 py-4 text-xs font-bold uppercase text-gray-400 tracking-wider">Velocidad</th>
                <th className="text-center px-5 py-4 text-xs font-bold uppercase text-gray-400 tracking-wider">Mejor para</th>
                <th className="text-right px-6 py-4 text-xs font-bold uppercase text-gray-400 tracking-wider">Acción</th>
              </tr>
            </thead>
            <tbody>
              {TABLE_DATA.map((row) => (
                <tr
                  key={row.id}
                  className={`border-b border-gray-100 last:border-none transition-colors ${
                    row.highlight ? 'bg-green-50/60' : 'hover:bg-slate-50/40'
                  }`}
                >
                  {/* Servicio */}
                  <td className="px-6 py-5">
                    <div className="flex items-center gap-3">
                      <div className={`w-11 h-11 flex-shrink-0 rounded-xl ${row.bg} flex items-center justify-center`}>
                        <span className="text-white text-xs font-bold">{row.initials}</span>
                      </div>
                      <div>
                        <div className="font-bold text-gray-900 flex items-center gap-2 flex-wrap">
                          {row.name}
                          {row.badge && (
                            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${row.badgeColor}`}>
                              {row.badge}
                            </span>
                          )}
                        </div>
                        <div className="text-gray-400 text-xs mt-0.5">{row.tagline}</div>
                      </div>
                    </div>
                  </td>
                  {/* Comisión */}
                  <td className="px-5 py-5 text-center">
                    <div className="flex flex-col items-center gap-1">
                      <span className={`text-xs font-bold px-3 py-1 rounded-lg border ${row.comisionColor}`}>
                        {row.comision}
                      </span>
                      <span className="text-gray-400 text-xs">{row.comisionLabel}</span>
                    </div>
                  </td>
                  {/* Velocidad */}
                  <td className="px-5 py-5 text-center">
                    <span className={`text-xs font-semibold px-3 py-1 rounded-lg border ${row.velocidadColor}`}>
                      {row.velocidad}
                    </span>
                  </td>
                  {/* Mejor para */}
                  <td className="px-5 py-5 text-center">
                    <span className="text-gray-600 text-xs bg-slate-100 px-3 py-1.5 rounded-lg font-medium">
                      {row.mejorPara}
                    </span>
                  </td>
                  {/* Acción */}
                  <td className="px-6 py-5 text-right">
                    <a
                      href={row.link}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all cursor-pointer whitespace-nowrap hover:scale-105 active:scale-95 ${row.btnColor}`}
                    >
                      {row.btnLabel}
                      <i className="ri-arrow-right-line" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col gap-4">
          {TABLE_DATA.map((row) => (
            <div
              key={row.id}
              className={`rounded-2xl border-2 p-5 bg-white ${
                row.highlight ? 'border-green-400' : 'border-gray-200'
              }`}
            >
              {row.highlight && (
                <div className="inline-flex items-center gap-1.5 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3">
                  <i className="ri-trophy-fill text-xs" />
                  #1 Recomendado
                </div>
              )}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-11 h-11 rounded-xl ${row.bg} flex items-center justify-center flex-shrink-0`}>
                    <span className="text-white text-xs font-bold">{row.initials}</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{row.name}</div>
                    <div className="text-gray-400 text-xs">{row.tagline}</div>
                  </div>
                </div>
                {row.badge && !row.highlight && (
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${row.badgeColor}`}>
                    {row.badge}
                  </span>
                )}
              </div>
              <div className="grid grid-cols-3 gap-3 mb-4">
                <div className="bg-slate-50 rounded-xl p-3 text-center">
                  <div className="text-xs text-gray-400 mb-1">Comisión</div>
                  <div className={`font-bold text-sm ${
                    row.comision === 'Baja' ? 'text-green-600' :
                    row.comision === 'Alta' ? 'text-red-500' : 'text-amber-600'
                  }`}>{row.comision}</div>
                  <div className="text-gray-400 text-xs">{row.comisionLabel}</div>
                </div>
                <div className="bg-slate-50 rounded-xl p-3 text-center">
                  <div className="text-xs text-gray-400 mb-1">Velocidad</div>
                  <div className="font-bold text-gray-800 text-xs leading-snug">{row.velocidad}</div>
                </div>
                <div className="bg-slate-50 rounded-xl p-3 text-center">
                  <div className="text-xs text-gray-400 mb-1">Mejor para</div>
                  <div className="font-bold text-gray-800 text-xs leading-snug">{row.mejorPara}</div>
                </div>
              </div>
              <a
                href={row.link}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className={`w-full flex items-center justify-center gap-2 py-3.5 rounded-xl text-sm font-bold transition-all cursor-pointer ${row.btnColor}`}
              >
                {row.btnLabel}
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="text-center text-gray-400 text-xs mt-6 leading-relaxed">
          * Las tasas y comisiones son referenciales y pueden variar. Verifica siempre en el sitio del proveedor antes de enviar.
        </p>
      </div>
    </section>
  );
}
